import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { CustomAlert, showToastAlert } from "../../admin/components/CustomAlert";
import { getAllCompanies } from "../../services/writerPost";
import { CompanyModal } from "./companyModal";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CompanyHome = () => {
    const [loaderOpen, setLoaderOpen] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editCompany, setEditCompany] = useState(null);
    const [allCompanies, setAllCompanies] = useState([]);
    const token = useSelector((state) => state.token);
    const navigate = useNavigate();

    const createCompany = () => {
        showToastAlert("Company Created", "success");
        setModalOpen(false);
        loadData();
    };
    const updateCompany = () => {
        showToastAlert("Company Updated", "success");
        setModalOpen(false);
        loadData();
    };

    const tableColumns = [
        {
            field: "name",
            headerName: "Company Name",
            flex: 1,
            editable: false,
        },
        {
            field: "lUrl",
            headerName: "LinkedIn URL",
            flex: 1,
            editable: false,
            renderCell: (params) => (
                params.row.lUrl ? (
                    <a href={params.row.lUrl} target="_blank" rel="noopener noreferrer">Linkedin</a>
                ) : "-"
            ),
        },
        {
            field: "logo",
            headerName: "Logo",
            flex: 0.5,
            editable: false,
            renderCell: (params) => (
                params.row.logo ? (
                    <img src={params.row.logo} alt="logo" style={{ width: 50, height: 50, objectFit: "contain", borderRadius: 4 }} />
                ) : "-"
            ),
        },
        {
            field: "action",
            headerName: "Action",
            flex: 1,
            minWidth: 230,
            editable: false,
            renderCell: (params) => (
                <Box display="flex" gap={1}>
                    <Tooltip title="Edit Company">
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<EditIcon />}
                            onClick={() => { setEditCompany(params.row); setModalOpen(true); }}
                        >
                            Edit
                        </Button>
                    </Tooltip>
                </Box>
            ),
        },
    ];

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            setLoaderOpen(true);
            const response = await getAllCompanies();
            setAllCompanies(response.data.companies || []);
            setLoaderOpen(false);
        } catch (err) {
            setLoaderOpen(false);
            showToastAlert("Failed to load companies", "error");
        }
    };

    return (
        <div className="container">
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "20px"
                }}
            >
                <Box mb={3}>
                    <Button
                        variant="outlined"
                        component={Link}
                        to="/writer"
                        startIcon={<ArrowBackIcon />}
                        sx={{ background: "yellow" }}
                    >
                        Home
                    </Button>
                </Box>
                <h1 className="page-title-1 my-3">Companies</h1>
                <Button onClick={() => { setEditCompany(null); setModalOpen(true); }} variant="contained" color="primary">
                    New Company
                </Button>
            </div>
            <Box
                sx={{
                    width: "100%",
                    height: {
                        xs: 300,
                        sm: 400,
                        md: 500,
                        lg: 600,
                        xl: 800,
                    },
                }}
            >
                <DataGrid
                    rows={allCompanies}
                    columns={tableColumns}
                    pageSize={10}
                    rowsPerPageOptions={[50]}
                    pagination
                    checkboxSelection
                    disableRowSelectionOnClick
                    slots={{ toolbar: GridToolbar }}
                    disableColumnMenu
                    disableColumnSelector
                    getRowId={(row) => row._id}
                    disableColumnFilter={false}
                    componentsProps={{
                        filterPanel: {
                            logicOperators: false,
                        },
                    }}
                />
                <CustomAlert />
            </Box>
            <CompanyModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                onCreate={createCompany}
                onUpdate={updateCompany}
                company={editCompany}
            />
        </div>
    );
};

export default CompanyHome;
